const APIprefix = process.env && process.env.REACT_APP_BFF_API;
const APIprefix_2 = process.env && process.env.REACT_APP_BFF_API_2;

export const gAPI_About_Property = `${APIprefix}/api/bot-response/about-property-response`;
export const gAPI_Property_Facilities = `${APIprefix}/api/bot-response/property-facilities-response`;
export const gAPI_Room_Amenities = `${APIprefix}/api/bot-response/room-amenities-response`;
export const gAPI_Property_Contact = `${APIprefix}/api/bot-response/property-contact-response`;
export const gAPI_Property_Activities = `${APIprefix}/api/bot-response/property-activities-response`;
export const gAPI_Property_Location = `${APIprefix}/api/bot-response/property-location-response`;
export const gAPI_Response_Test = `${APIprefix}/api/bot-response/test-response`;
export const gAPI_Special_Emergenices = `${APIprefix}/api/bot-response/special-emergencies-response`;
export const gAPI_RH_About_Property = `${APIprefix}/api/bot-response/about-rhproperty-response`;
export const postAPI_Create_A_Message = `${APIprefix}/api/bot-response/messages`;
export const putAPI_Update_Response = `${APIprefix}/api/bot-response/update-response`;
export const putAPI_Delete_Response = `${APIprefix}/api/bot-response/delete`;
export const gAPI_Response_RelatedTopics = `${APIprefix}/api/bot-response/related-topics-response`;
export const gAPI_Response_AssistantOptions = `${APIprefix}/api/bot-response/assistant-setup-response`;
export const gAPI_Response_HotelAssistantOptions = `${APIprefix}/api/bot-response/hotel-assistant-setup-response`;
export const gAPI_Response_SalonInformation = `${APIprefix}/api/bot-response/salon-information-response`;
export const gAPI_Response_SalonServices = `${APIprefix}/api/bot-response/salon-services-response`;
export const gAPI_Response_SalonAssistantOptions = `${APIprefix}/api/bot-response/salon-assistant-setup-response`;
export const gAPI_Response_HPContact = `${APIprefix}/api/bot-response/hp-contact-response`;
export const gAPI_Response_HPLocation = `${APIprefix}/api/bot-response/hp-location-response`;
export const gAPI_Response_HPFacilities = `${APIprefix}/api/bot-response/hp-facilities-response`;
export const gAPI_Response_HPInformation = `${APIprefix}/api/bot-response/hp-information-response`;
export const gAPI_Response_HPAssistantOptions = `${APIprefix}/api/bot-response/hp-assistant-setup-response`;
export const gAPI_Response_QbotInformation = `${APIprefix}/api/bot-response/qbot-property-information-response`;
export const gAPI_Response_QbotAssistantOptions = `${APIprefix}/api/bot-response/qbot-assistant-setup-response`;
export const gAPI_Response_HHInformation = `${APIprefix}/api/bot-response/hh-property-information-response`;
export const gAPI_Response_HHAssistantOptions = `${APIprefix}/api/bot-response/hh-assistant-setup-response`;
export const gAPI_Response_HHAmenties = `${APIprefix}/api/bot-response/hh-amenities-response`;
export const gAPI_Response_HHPolicies = `${APIprefix}/api/bot-response/hh-policies-response`;
export const gAPI_Response_HHBedrooms = `${APIprefix}/api/bot-response/hh-bedrooms-response`;
export const gAPI_Property_List = `${APIprefix_2}/api/property`;
export const gAPI_Response_VVNAssistantOptions = `${APIprefix}/api/bot-response/vvn-assistant-setup-response`;
export const gAPI_Response_VVNInformation = `${APIprefix}/api/bot-response/vvn-information-response`;
export const gAPI_Response_Details = `${APIprefix}/api/bot-response/response-code-details`;
export const gAPI_Response_DCAssistantOptions = `${APIprefix}/api/bot-response/dc-assistant-setup-response`;
export const gAPI_Response_DCInformation = `${APIprefix}/api/bot-response/dc-information-response`;
export const gAPI_Response_DCVoice = `${APIprefix}/api/bot-response/dc-voice-response`;
export const gAPI_Response_GolfProperty = `${APIprefix}/api/bot-response/golf-property`;
export const gAPI_Response_GolfServices = `${APIprefix}/api/bot-response/golf-services`;
export const gAPI_Response_GolfGeneral = `${APIprefix}/api/bot-response/golf-general`;
export const gAPI_Response_NorthableAbout = `${APIprefix}/api/bot-response/northable-about`;
export const gAPI_Response_NorthableEquipment = `${APIprefix}/api/bot-response/northable-equipment`;
export const gAPI_Response_NorthableHelpLine = `${APIprefix}/api/bot-response/northable-helpline`;
export const API_EmbedVoucher_Connection = `${APIprefix}/api/integrations/embedVoucher`;
export const API_Xola_Connection = `${APIprefix}/api/integrations/xola`;
export const API_CustomStripe_Connection = `${APIprefix}/api/integrations/custom-stripe`;
export const API_Xola = `${APIprefix}/api/xola`;
export const API_CloudBeds = `${APIprefix}/api/integrations/cloudBeds`;
export const API_CloudBeds_Connection = `${APIprefix}/api/cloudbeds`;
export const API_StandAlonePage_Connection = `${APIprefix}/api/integrations/hostedPage`;
export const postAPI_Create_Ingetration = `${APIprefix}/api/integrations/create`;
export const postAPI_Create_VocuherWebiste_Ingetration = `${APIprefix}/api/integrations/voucher`;
export const gAPI_Ingetration = `${APIprefix_2}/api/integrations`;
export const API_Ingetration = `${APIprefix_2}/api/integrations`;
export const putAPI_Update_Ingetration = `${APIprefix}/api/integrations`;
export const dAPI_Delete_Ingetration = `${APIprefix_2}/api/integrations/delete`;
export const gAPI_Stripe_Ingetration = `${APIprefix}/api/integrations/stripe`;
export const gAPI_Standard_Stripe_Ingetration = `${APIprefix_2}/api/integrations/standard-stripe`;
export const postAPI_Create_FacebookIntegration = `${APIprefix}/api/integrations/create/facebook`;
export const postAPI_Create_PhoneIntegration = `${APIprefix}/api/integrations/create/phone`;
export const postAPI_Create_GoogleBuisnessIntegration = `${APIprefix}/api/integrations/create/google-business`;
export const postAPI_Create_RevinateIntegration = `${APIprefix}/api/integrations/create/revinate`;
export const putAPI_Update_RevinateIntegration = `${APIprefix}/api/integrations/update-revinate`;
export const postAPI_Create_FacebookIntegrationInGroupService = `${APIprefix}/api/integrationsgroup/create/facebook-in-group`;
export const postAPI_Create_GoogleBuisnessIntegrationInGroupService = `${APIprefix}/api/integrationsgroup/create/google-business-in-group`;
export const postAPI_Create_PhoneIntegrationInGroupService = `${APIprefix}/api/integrationsgroup/create/phone-in-group`;
export const postAPI_Update_FacebookIntegration = `${APIprefix}/api/integrations/update-facebook`;
export const putAPI_Update_PhoneIntegration = `${APIprefix}/api/integrations/update-phone`;
export const gAPI_FBIngetration = `${APIprefix}/api/integrationsgroup/facebook`;
export const gAPI_GoogleBusinessIngetration = `${APIprefix}/api/integrationsgroup/google-business`;
export const gAPI_FBIntegrationByPropertyId = `${APIprefix}/api/integrationsgroup/facebook-pages-property`;
export const putAPI_Update_Ingetration_Group = `${APIprefix}/api/integrationsgroup/facebook`;
export const dAPI_Delete_Ingetration_Group = `${APIprefix}/api/integrationsgroup/facebook`;
export const putAPI_Update_PhoneIngetration_Group = `${APIprefix}/api/integrationsgroup/phone`;
export const dAPI_Delete_PhoneIngetration_Group = `${APIprefix}/api/integrationsgroup/phone`;
export const postAPI_Update_VisitorSettings = `${APIprefix}/api/integrations/update-visitorsettings`;
export const postAPI_Update_InActivePopupSettings = `${APIprefix}/api/integrations/update-inactivepopsettings`;
export const putAPI_Update_NudgesButton = `${APIprefix}/api/integrations/update-nudgesbutton`;
export const putAPI_Update_OnOff = `${APIprefix_2}/api/integrations/update-onoff`;
// Wechat API's
export const gAPI_WechatIntegration = `${APIprefix}/api/integrations/wechat`;
export const postAPI_Create_WechatIngetration_Group = `${APIprefix}/api/integrationsgroup/create/wechat-in-group`;
export const gAPI_WechatIngetration_Group = `${APIprefix}/api/integrationsgroup/wechat`;
export const gAPI_Account_WechatIngetrationBy_Property_Group = `${APIprefix}/api/integrationsgroup/wechat-account-property`;

// Google Tag Manager Api
export const API_GTMIntegration = `${APIprefix_2}/api/integrations/gtm`;


/** Amadeus Integration APIs */
export const pAPI_amadeus = `${APIprefix}/api/integrations/amadeus`;
export const pAPI_mews = `${APIprefix}/api/integrations/mews`;
export const API_PAYPAL = `${APIprefix_2}/api/integrations/paypal`;
export const gAPI_Mews_Rooms = `${APIprefix}/public/mews`;
export const API_Mews = `${APIprefix}/public/mews`;
export const gAPI_Visitors_Stats = `${APIprefix}/api/stats/visitors`;
export const gAPI_Visitors = `${APIprefix}/api/integrations`;
export const gAPI_VisitorsGroups_Stats = `${APIprefix}/api/groups/visitorstats`;
export const gAPI_CountriesGroups_Stats = `${APIprefix}/api/groups/countriestats`;
export const gAPI_VisitorsGroupsMonth_Stats = `${APIprefix}/api/groups/visitorstatsmonth`;
export const gAPI_VisitorsGroupsContact_Stats = `${APIprefix}/api/groups/aiva/contactstats`;
export const gAPI_Topics_Stats = `${APIprefix}/api/stats/topics`;
export const gAPI_Percentage_Stats = `${APIprefix}/api/stats/percentage`;
export const gAPI_Countries_Stats = `${APIprefix}/api/stats/countries`;
export const gAPI_Conversations_Stats = `${APIprefix}/api/stats/conversations`;
export const gAPI_Conversations_Night_Stats = `${APIprefix}/api/stats/conversations-night`;
export const gAPI_Conversations_VisitorQuestions = `${APIprefix}/api/stats/userquestions`;
export const gAPI_Conversations_Stats_Year = `${APIprefix}/api/stats/conversations-year`;
export const gAPI_Conversations_Night_Year_Stats = `${APIprefix}/api/stats/conversations-year-night`;
export const gAPI_Visitors_Stats_Year = `${APIprefix}/api/stats/visitors-year`;
export const gAPI_Recommender_Stats = `${APIprefix}/api/questions/recommenderstats`;

export const gAPI_Number_Stats = `${APIprefix}/api/stats/number`;
export const gAPI_Conversations_Time_Stats = `${APIprefix}/api/stats/conversations-time`;
export const gAPI_Conversations_Night_Time_Stats = `${APIprefix}/api/stats/conversations-night-time`;
export const gAPI_Conversations_Time_Year_Stats = `${APIprefix}/api/stats/conversations-year-time`;
export const gAPI_Conversations_Night_Year_Time_Stats = `${APIprefix}/api/stats/conversations-year-night-time`;

export const gAPI_Rooms = `${APIprefix_2}/api/room`;
export const gAPI_Amadues_Rooms = `${APIprefix_2}/public/amadeus`;
export const postAPI_Create_Room = `${APIprefix_2}/api/room/create`;
export const postAPI_Update_Rooms_Images = `${APIprefix_2}/api/room/image/update`;
export const gAPI_Room_ById = `${APIprefix_2}/api/room/detail`;
export const gAPI_RoomDelete_ById = `${APIprefix_2}/api/room`;
export const postAPI_Update_Room = `${APIprefix_2}/api/room/update`;

export const gAPI_Ari_Room = `${APIprefix_2}/api/ari`;
export const postAPI_Update_Inventory = `${APIprefix_2}/api/ari/inventory`;
export const postAPI_Update_Restrictions = `${APIprefix_2}/api/ari/restrictions`;
export const postAPI_Update_Rates = `${APIprefix_2}/api/ari/rates`;
/**
 * ARI APIs
 * */
/** Add On's APIs */
export const gAPI_AddOns_List = `${APIprefix_2}/api/ari/addons-list`;
export const gAPI_AddOns_By_Id = `${APIprefix_2}/api/ari/addons/get`;
export const postAPI_Create_AddOns = `${APIprefix_2}/api/ari/addons/create`;
export const putAPI_Update_AddOns = `${APIprefix_2}/api/ari/addons/update`;
export const putAPI_Update_AddOns_Images = `${APIprefix_2}/api/ari/addons/update-images`;
/** Promos APIs */
export const gAPI_Promos_List = `${APIprefix_2}/api/ari/promos-list`;
export const gAPI_Promos_By_Id = `${APIprefix_2}/api/ari/promos/get`;
export const postAPI_Create_Promos = `${APIprefix_2}/api/ari/promos/create`;
export const putAPI_Update_Promos = `${APIprefix_2}/api/ari/promos/update`;
export const putAPI_Update_Promos_Images = `${APIprefix_2}/api/ari/promos/update-images`;

/** Rate Plan's APIs */
export const gAPI_RatePlans_List = `${APIprefix_2}/api/ari/rateplans-list`;
export const gAPI_RatePlans_By_Id = `${APIprefix_2}/api/ari/rateplans/get`;
export const postAPI_Create_RatePlans = `${APIprefix_2}/api/ari/rateplans/create`;
export const putAPI_Update_RatePlans = `${APIprefix_2}/api/ari/rateplans/update`;
export const putAPI_Update_RatePlan_RoomMapping = `${APIprefix_2}/api/ari/rateplans/rooms-mapping`;
export const gAPI_Rooms_List = `${APIprefix_2}/api/ari/rooms-list`;
export const gAPI_RatesPlan_List_ByRoomId = `${APIprefix_2}/api/ari/rateplans-list-linked`;
export const gAPI_LinkedRoomList_ByPropertyId = `${APIprefix_2}/api/ari/roomtypes-list-linked`;

/** Bookings's APIs */
export const gAPI_Bookings_list = `${APIprefix_2}/api/ari/bookings-list`;
export const gAPI_Booking_By_Id = `${APIprefix_2}/api/ari/booking`;
export const postAPI_ConfirmBooking = `${APIprefix_2}/api/ari/bookings/confirm`;
export const postAPI_CancelBooking = `${APIprefix_2}/api/ari/bookings/cancel`;
export const postAPI_ConfirmBookingEmail = `${APIprefix_2}/api/ari/bookings/confirmbyemail`;
/** Bookings's APIs */
export const gAPI_Conversations_list = `${APIprefix_2}/api/conversations/list`;
export const gAPI_Conversations_Activelist = `${APIprefix_2}/api/conversations/active`;
export const gAPI_Conversations_By_Id = `${APIprefix_2}/api/conversations/get`;
export const putAPI_ConversationsStatus_By_Id = `${APIprefix_2}/api/conversations/update-status`;
export const putAPI_ConversationsTwilioStart = `${APIprefix_2}/api/conversations/TwilioStart`;
export const putAPI_ConversationsTwilioEnd = `${APIprefix_2}/api/conversations/TwilioEnd`;
export const gAPI_Conversations_By_BotConversation = `${APIprefix_2}/api/conversations/getByBotConversation`;
export const gAPI_BotConversations_list = `${APIprefix_2}/api/conversations/latestbot`;
export const gAPI_AgentConversations_list = `${APIprefix_2}/api/conversations/latestagent`;
/** Groups and Properties */
export const gAPI_Groups = `${APIprefix_2}/api/groups/list`;
export const postAPI_Create_Group = `${APIprefix_2}/api/groups/create`;
export const putAPI_Update_Group = `${APIprefix_2}/api/groups/update`;
export const putAPI_UpdateStatus_Group = `${APIprefix_2}/api/groups/updatestatus`;
export const postAPI_Create_Property = `${APIprefix_2}/api/property/create`;
export const postAPI_Update_Property = `${APIprefix_2}/api/property/update`;
export const gAPI_Group_By_Id = `${APIprefix_2}/api/groups/get`;
export const gAPI_OnboardGroup_By_Id = `${APIprefix_2}/api/groups/getonboard`;
export const gAPI_Internal_Property_List = `${APIprefix_2}/api/property/internal`;
export const gAPI_Internal_Property_By_Id = `${APIprefix_2}/api/property/internal`;
export const putAPI_Update_Contacts = `${APIprefix_2}/api/property/update-contacts`;
export const putAPI_Update_Domains = `${APIprefix_2}/api/property/update-domains`;
export const postAPI_Onboard = `${APIprefix_2}/public/groups/onboard`;
export const gAPI_CheckUser_Property = `${APIprefix_2}/api/property/verifyuser`;
export const gAPI_CheckUser_Groups = `${APIprefix_2}/api/groups/verifyuser`;
export const gAPI_Users_LinkedProperties_By_Id = `${APIprefix_2}/api/property/linkedproperties`;

/** Tickets */
export const gAPI_Tickets_list = `${APIprefix_2}/api/tickets/list`;
export const gAPI_Tickets_By_Id = `${APIprefix_2}/api/tickets/get`;
export const postAPI_Create_Ticket = `${APIprefix_2}/api/tickets/create`;
export const putAPI_Update_Ticket = `${APIprefix_2}/api/tickets/update`;
export const gAPI_TicketsRecording_id = `${APIprefix_2}/api/tickets/recordingurl`;
export const postAPI_Ticket_SendText = `${APIprefix_2}/api/tickets/sendtext`;
/** Users */
export const gAPI_Users_list = `${APIprefix_2}/api/users/list`;
export const gAPI_Users_By_Id = `${APIprefix_2}/api/users/get`;
export const gAPI_Users_LinkedGrups_By_Id = `${APIprefix_2}/api/groups/linkedgroups`;
export const postAPI_Create_User = `${APIprefix_2}/api/users/create`;
export const postAPI_Update_User = `${APIprefix_2}/api/users/update`;
export const postAPI_Invite_User = `${APIprefix_2}/api/users/invite`;
export const postAPI_Verify_User = `${APIprefix_2}/public/verify`;
export const postAPI_UpdatePassword = `${APIprefix_2}/api/users`;
export const postAPI_ResetPassword = `${APIprefix_2}/public`;
export const postAPI_ForgotPassword = `${APIprefix_2}/public-user/forgot-password`;
export const postAPI_Users_ForgotPassword = `${APIprefix_2}/api/users/forgot-password`;
export const postAPI_VerifyForgotPassword = `${APIprefix_2}/public/verify-forgot-password`;
export const postAPI_Signup_User = `${APIprefix_2}/public/signup`;
export const postAPI_ResendInvite = `${APIprefix_2}/api/users`;
export const postAPI_GenerateInvite = `${APIprefix_2}/api/users`;
export const postAPI_EmailCheck = `${APIprefix_2}/public/email-check`;
export const putAPI_AgentStatus = `${APIprefix_2}/api/users`;
export const postAPI_ForgotPin = `${APIprefix_2}/public-user/forgot-pin`;
export const postAPI_UpdatePin = `${APIprefix_2}/api/users`;
export const postAPI_ResetPin = `${APIprefix_2}/public`;
export const gAPI_Search_Users_list = `${APIprefix_2}/api/users/search`;

/* Services */
export const gAPI_Services = `${APIprefix_2}/api/services/list`;
export const postAPI_Create_Services = `${APIprefix_2}/api/services/create`;
export const putAPI_Update_Service = `${APIprefix_2}/api/services/update`;
export const gAPI_Service_By_Id = `${APIprefix_2}/api/services/get`;
export const putAPI_Delete_Service = `${APIprefix_2}/api/services/delete`;

/* Locations */
export const gAPI_Locations = `${APIprefix_2}/api/locations/list`;
export const postAPI_Create_Location = `${APIprefix_2}/api/locations/create`;
export const putAPI_Update_Location = `${APIprefix_2}/api/locations/update`;
export const gAPI_Location_By_Id = `${APIprefix_2}/api/locations/get`;
export const putAPI_Delete_Location = `${APIprefix_2}/api/locations/delete`;

/* Images */
export const postAPI_User_Images = `${APIprefix}/api/images/user`;
export const postAPI_Vouchers_fonts = `${APIprefix_2}/api/vouchers/font`;
export const postAPI_Vouchers_Icons = `${APIprefix_2}/api/vouchers/voucherIcons`;
export const gAPI_Vouchers_Icons = `${APIprefix_2}/api/vouchers/voucherIcons`;
export const dAPI_Vouchers_Icons = `${APIprefix_2}/api/vouchers/delete-icon`;
export const putAPI_Vouchers_Order = `${APIprefix}/api/vouchers/displayOrder`;
export const API_TODO_JSON = `${APIprefix}/api/todo`;
export const postAPI_Bmb_Images = `${APIprefix_2}/api/images/bmb`;
export const gAPI_UserUploads = `${APIprefix_2}/api/images/user-uploads`;
export const gAPI_BmbUploads = `${APIprefix_2}/api/images/bmb-uploads`;
export const putAPI_Update_Image = `${APIprefix_2}/api/images/update`;
export const putAPI_Delete_Image = `${APIprefix_2}/api/images/delete`;
export const postAPI_User_External_Images = `${APIprefix_2}/api/images/user-uploads-external`;
/* Templates */
export const gAPI_TemplatePromoList = `${APIprefix_2}/api/templates/list-template-promos`;
export const gAPI_CopyPromo = `${APIprefix_2}/api/templates/copy-promos`;
export const gAPI_TemplateAddOnList = `${APIprefix_2}/api/templates/list-template-addons`;
export const gAPI_CopyAddOn = `${APIprefix_2}/api/templates/copy-addons`;
export const gAPI_TemplateServicesList = `${APIprefix_2}/api/templates/list-template-services`;
export const gAPI_CopyServices = `${APIprefix_2}/api/templates/copy-services`;

/** Guests */
export const gAPI_Guests_List = `${APIprefix_2}/api/ari/checkinguests-list`;
export const gAPI_Guests_By_Id = `${APIprefix_2}/api/ari/checkinguests/get`;
export const postAPI_Create_Guests = `${APIprefix_2}/api/ari/checkinguests/create`;
export const putAPI_Update_Guests = `${APIprefix_2}/api/ari/checkinguests/update`;
export const dAPI_Delete_Guests = `${APIprefix_2}/api/ari/checkinguests/delete`;

/**Products */
export const gAPI_Products_List = `${APIprefix_2}/public/products/list`;

/**Unsubscribe */
export const dAPI_Unsubscribe = `${APIprefix_2}/public/unsubscribe-contact`;

/* Subscription */
export const gAPI_Subscription_By_Group_Id = `${APIprefix_2}/api/subscriptions/get`;
export const postAPI_Create_Subscription = `${APIprefix_2}/api/subscriptions/create`;
export const putAPI_Update_Subscription = `${APIprefix_2}/api/subscriptions/update`;
export const gAPI_Subscription_By_Id = `${APIprefix_2}/api/subscriptions/get`;
export const putAPI_Delete_Subscription = `${APIprefix_2}/api/subscriptions/delete`;

/* Questions */
export const gAPI_QuestionSets = `${APIprefix_2}/api/questions/set/list`;
export const postAPI_Create_QuestionSet = `${APIprefix_2}/api/questions/set/create`;
export const putAPI_Update_QuestionSet = `${APIprefix_2}/api/questions/set/update`;
export const gAPI_QuestionSet_By_Id = `${APIprefix_2}/api/questions/set/get`;
export const putAPI_Delete_QuestionSet = `${APIprefix_2}/api/questions/set/delete`;

export const postAPI_Create_Question = `${APIprefix_2}/api/questions/question/create`;
export const putAPI_Update_Question = `${APIprefix_2}/api/questions/question/update`;
export const gAPI_Question_By_Id = `${APIprefix_2}/api/questions/question/get`;
export const putAPI_Delete_Question = `${APIprefix_2}/api/questions/question/delete`;

export const postAPI_Create_Question_Option = `${APIprefix_2}/api/questions/questionoption/create`;
export const putAPI_Update_Question_Option = `${APIprefix_2}/api/questions/questionoption/update`;
export const gAPI_Question_Option_By_Id = `${APIprefix_2}/api/questions/questionoption/get`;
export const putAPI_Delete_Question_Option = `${APIprefix_2}/api/questions/questionoption/delete`;
export const gAPI_QuestionOptionList = `${APIprefix_2}/api/questions/questionoption/list`;
/* products */
export const gAPI_Business = `${APIprefix_2}/api/propertyproduct/list`;
export const postAPI_Create_Business = `${APIprefix_2}/api/propertyproduct/create`;
export const putAPI_Update_Business = `${APIprefix_2}/api/propertyproduct/update`;
export const gAPI_Business_By_Id = `${APIprefix_2}/api/propertyproduct/get`;
export const putAPI_Delete_Business = `${APIprefix_2}/api/propertyproduct/delete`;

export const gAPI_QuickReplies = `${APIprefix_2}/api/quick-replies/list`;
export const postAPI_Create_QuickReply = `${APIprefix_2}/api/quick-replies/create`;
export const putAPI_Update_QuickReply = `${APIprefix_2}/api/quick-replies/update`;
export const gAPI_QuickReply_ById = `${APIprefix_2}/api/quick-replies/get`;
export const gAPI_QuickReplyDelete_ById = `${APIprefix_2}/api/quick-replies/delete`;

export const gAPI_BotDialogFile = `${APIprefix_2}/api/botdialog/file`;
export const postAPI_BotDialogFile = `${APIprefix_2}/api/botdialog/file`;
export const postAPI_UploadBotDialogFile = `${APIprefix_2}/api/botdialog/upload`;

/** Promo Codes APIs */
export const gAPI_Promo_Codes_List = `${APIprefix_2}/api/promoCodes/list`;
export const gAPI_Promo_Codes_By_Id = `${APIprefix_2}/api/promoCodes/get`;
export const dAPI_Promo_Codes_By_Id = `${APIprefix_2}/api/promoCodes/delete`;
export const postAPI_Create_Promo_Codes = `${APIprefix_2}/api/promoCodes/create`;
export const putAPI_Update_Promo_Codes = `${APIprefix_2}/api/promoCodes/update`;
/** Vouchers APIs */
export const gAPI_Vouchers_List = `${APIprefix}/api/vouchers/list`;
export const gAPI_MembershipTags = `${APIprefix}/api/vouchers/tags`;
export const gAPI_Vouchers = `${APIprefix_2}/api/vouchers/vouchers-list`;
export const gAPI_Vouchers_By_Id = `${APIprefix}/api/vouchers/get`;
export const dAPI_Vouchers_By_Id = `${APIprefix}/api/vouchers/delete`;
export const API_Vouchers_Codes = `${APIprefix_2}/api/vouchers/codes`;
export const postAPI_Create_Vouchers = `${APIprefix_2}/api/vouchers/create`;
export const putAPI_Update_Vouchers = `${APIprefix}/api/vouchers/update`;
export const post_API_Send_Email = `${APIprefix_2}/api/vouchers/email`;
export const post_API_Send_EmbedVoucher_Email = `${APIprefix_2}/api/vouchers/email/embedVoucher`;
export const postAPI_TrackEvent = `${APIprefix}/api/stats/track-activecampaign`;

export const gAPI_Favourite = `${APIprefix}/api/bot-response/favourite-response`;
export const postAPI_Favourite = `${APIprefix}/api/favourite-response`;

export const putAPI_approve_voucher = `${APIprefix_2}/api/vouchers/approve`;
export const postAPI_Invitation = `${APIprefix_2}/api/vouchers/invite/add`;
export const putAPI_Invitation = `${APIprefix_2}/api/vouchers/invite/update`;
export const gAPI_Invitation_By_Email = `${APIprefix_2}/api/vouchers/invitation/get`;
export const gAPI_Invitation_By_Property = `${APIprefix_2}/api/vouchers/invitation`;
export const gAPI_Check_Invitation = `${APIprefix_2}/api/vouchers/invitation/email`;
export const putAPi_Accept_Invitation = `${APIprefix_2}/api/vouchers/connected`;

export const postAPI_Voucher_Stats = `${APIprefix_2}/api/vouchers/stats`;
export const gAPI_Voucher_Stats = `${APIprefix_2}/api/vouchers/stats`;
export const gAPI_Voucher_Ads_Stats = `${APIprefix_2}/api/vouchers/ads`;
export const gAPI_Voucher_Country_Stats = `${APIprefix_2}/api/vouchers/countriestats`;
export const gAPI_Voucher_Engine_Stats = `${APIprefix_2}/api/vouchers/voucherengine/stats`;
export const gAPI_Voucher_Engine_Sales = `${APIprefix_2}/api/vouchers/voucherengine/sales`;
export const gAPI_Voucher_Engine_Share_Stats = `${APIprefix_2}/api/vouchers/voucherengine/share`;

/** Stripe APIs */
export const gAPI_Stripe_Connection = `${APIprefix_2}/public/stripe`;
export const gAPI_Voucher_Payment = `${APIprefix_2}/api/payments`;
export const gAPI_Stripe_PromoCode = `${APIprefix_2}/public/stripe/validpromo`;

export const gAPI_Orders_Voucher = `${APIprefix_2}/api/orders`;
export const API_Orders_Voucher = `${APIprefix_2}/api/orders`;
export const API_Order_Voucher_Notes = `${APIprefix_2}/api/orders/notes`;
export const API_Order_Voucher_Pdf = `${APIprefix_2}/api/orders/pdf`;
export const postAPI_Voucher_Statement = `${APIprefix_2}/api/orders/statement`;
export const postAPI_Voucher_Send_Statement = `${APIprefix_2}/api/orders/send/statement`;
/** Widget APIs */
export const gAPI_WidgetBy_PropertyId = `${APIprefix}/api/widgets`;
export const gAPI_WidgetById = `${APIprefix}/api/widgets/detail`;
export const postAPI_Create_Widget = `${APIprefix}/api/widgets/create`;
export const putAPI_Update_Widget = `${APIprefix}/api/widgets/update`;
export const dAPI_Delete_Widget = `${APIprefix}/api/widgets/delete`;
export const putAPI_UpdateList_Widget = `${APIprefix}/api/widgets/update-list`;
export const putAPI_UpdatePositionList_Widget = `${APIprefix}/api/widgets/update-position-list`;

/** Predict APIs */
export const gAPI_GetPlace_Predict = `${APIprefix}/api/predict/place`;
export const gAPI_GetEvent_By_Place_Predict = `${APIprefix}/api/predict/event/place`;
export const gAPI_GetEvent_By_Miles_Predict = `${APIprefix}/api/predict/event/miles`;
export const gAPI_GetEvent_By_Country_Predict = `${APIprefix}/api/predict/event/country`;

// Custom Urls
export const API_Custom_Urls = `${APIprefix}/api/vouchers/custom-urls`;


export const putAPI_ConversationsFacebookTransfer = `${APIprefix_2}/api/conversations/FacebookTransfer`;
export const putAPI_UpdateAgentStatus_By_Id = `${APIprefix_2}/api/conversations/update-agent-status`;
export const putAPI_UpdateChatStatus_By_Id = `${APIprefix_2}/api/conversations/update-chat-status`;
